import React, { forwardRef, useState, useImperativeHandle } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import PlainTextField from "../InputField/PlainTextField";

const ProjectDescription = forwardRef((props, ref) => {
    const [hasError, setHasError] = useState(false);
    const [formValues, setFormValues] = useState(
        props.formData
            ? props.formData
            : {
                  projectDescription: "",
                  spaceDescription: "",
              }
    );

    useImperativeHandle(ref, () => ({
        validate() {
            return isValidData();
        },
    }));

    const isValidData = () => {
        if (formValues?.projectDescription != "") return true;
        else return false;
    };

    const handleChange = (id, value) => {
        setHasError(false);
        let newFormValues = { ...formValues };
        newFormValues[id] = value;
        setFormValues(newFormValues);
        props.onChange(newFormValues);
    };

    return (
        <Grid container>
            <Grid item xs={12} md={12}>
                <PlainTextField
                    id="projectDescription"
                    label="Project Description"
                    placeholder="Please describe the goals of your installation."
                    name="projectDescription"
                    margin="normal"
                    isRequired={false}
                    fullWidth
                    multiline={true}
                    minRows={6}
                    maxRows={50}
                    value={formValues.projectDescription}
                    onChange={(value) => handleChange("projectDescription", value)}
                />
            </Grid>
            <Grid item xs={12} md={12}>
                <PlainTextField
                    id="spaceDescription"
                    label="Space Description"
                    placeholder="Please provide a description of the space or locations where you would like to have student art installed."
                    margin="normal"
                    isRequired={false}
                    fullWidth
                    multiline={true}
                    minRows={6}
                    maxRows={50}
                    value={formValues.spaceDescription}
                    onChange={(value) => handleChange("spaceDescription", value)}
                />
            </Grid>
        </Grid>
    );
});

export { ProjectDescription };
